import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import css from './index.module.scss';
import SwiperCard from './swiperCard';
import { useGlobal } from '@/utils/useGlobal';

export default function Solutions({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    const itemsMap: any = {
        us: [
            {
                id: 'StarterKit',
                img: 'pc/ef_1',
                name: t('secE_item1_title_1'),
                device: t('secE_item1_title_2'),
                power: t('secE_item1_title_3'),
                desc: t('secE_item1_title_4'),
                buyLink: `https://us.ecoflow.com/products/delta-pro-portable-power-station`,
            },
            {
                id: 'StarterKit1',
                img: 'pc/ef_2',
                name: t('secE_item4_title_1'),
                device: t('secE_item4_title_2'),
                power: t('secE_item4_title_3'),
                desc: t('secE_item4_title_4'),
                buyLink: `https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=40539815673929`,
            },
            {
                id: 'AdvancedKit',
                img: 'pc/g-5',
                name: t('secE_item2_title_1'),
                device: t('secE_item2_title_2'),
                power: t('secE_item2_title_3'),
                desc: t('secE_item2_title_4'),
                buyLink: `https://us.ecoflow.com/products/delta-pro-double-voltage-hub`,
            },
            {
                id: 'SmartControlKit',
                img: 'pc/e-1',
                name: t('secE_item3_title_1'),
                device: t('secE_item3_title_2'),
                power: t('secE_item3_title_3'),
                desc: t('secE_item3_title_4'),
                buyLink: `https://us.ecoflow.com/products/ecoflow-delta-pro-smart-home-panel`,
            },
        ],
        ca: [
            {
                id: 'StarterKit0',
                img: 'DPU+TS(30A)',
                name: t('secE_item4_title_1'),
                device: t('secE_item4_title_2'),
                power: t('secE_item4_title_3'),
                desc: t('secE_item4_title_4'),
                buyLink: `https://ca.ecoflow.com/pages/delta-pro-ultra`,
            },
            {
                id: 'StarterKit1',
                img: 'https://websiteoss.ecoflow.com/upload/image/1723023664330/DP3%2BSHP%20(1).png',
                name: t('secE_item5_title_1'),
                device: t('secE_item5_title_2'),
                power: t('secE_item5_title_3'),
                desc: t('secE_item5_title_4'),
                buyLink: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station?variant=44902384730266',
            },
            {
                id: 'StarterKit',
                img: 'pc/ef_1',
                name: t('secE_item1_title_1'),
                device: t('secE_item1_title_2'),
                power: t('secE_item1_title_3'),
                desc: t('secE_item1_title_4'),
                buyLink: `https://ca.ecoflow.com/products/delta-pro-portable-power-station`,
            },
            {
                id: 'AdvancedKit',
                img: 'pc/g-5',
                name: t('secE_item2_title_1'),
                device: t('secE_item2_title_2'),
                power: t('secE_item2_title_3'),
                desc: t('secE_item2_title_4'),
                buyLink: `https://ca.ecoflow.com/products/delta-pro-double-voltage-hub`,
            },
            // {
            //     id: 'SmartControlKit',
            //     img: 'pc/e-1',
            //     name: t('secE_item3_title_1'),
            //     device: t('secE_item3_title_2'),
            //     power: t('secE_item3_title_3'),
            //     desc: t('secE_item3_title_4'),
            //     buyLink: `https://ca.ecoflow.com/products/ecoflow-delta-pro-smart-home-panel`,
            // },
        ],
        sa: [
            {
                id: 'River2ProKit',
                img: 'product/bundle_river2_pro_ts',
                name: t('secE_item3_title_1'),
                device: t('secE_item3_title_2'),
                power: t('secE_item3_title_3'),
                desc: t('secE_item3_title_4'),
                buyLink: '',
            },
            {
                id: 'Delta2Kit',
                img: 'product/bundle_delta2_ts',
                name: t('secE_item1_title_1'),
                device: t('secE_item1_title_2'),
                power: t('secE_item1_title_3'),
                desc: t('secE_item1_title_4'),
                buyLink: '',
            },
            {
                id: 'DeltaProKit',
                img: 'product/bundle_delta_pro_ts',
                name: t('secE_item2_title_1'),
                device: t('secE_item2_title_2'),
                power: t('secE_item2_title_3'),
                desc: t('secE_item2_title_4'),
                buyLink: '',
            },
        ],
        za: [
            {
                id: 'River2ProKit',
                img: 'product/bundle_river_pro_ts',
                name: t('secE_item1_title_1'),
                device: t('secE_item1_title_2'),
                power: t('secE_item1_title_3'),
                desc: t('secE_item1_title_4'),
                buyLink: 'https://za.ecoflow.com/products/river-pro-portable-power-station',
            },
            {
                id: 'Delta2Kit',
                img: 'product/bundle_delta2_ts_za',
                name: t('secE_item2_title_1'),
                device: t('secE_item2_title_2'),
                power: t('secE_item2_title_3'),
                desc: t('secE_item2_title_4'),
                buyLink: 'https://za.ecoflow.com/products/delta-2-portable-power-station',
            },
            {
                id: 'DeltaProKit',
                img: 'product/bundle_delta_pro_ts_za',
                name: t('secE_item3_title_1'),
                device: t('secE_item3_title_2'),
                power: t('secE_item3_title_3'),
                desc: t('secE_item3_title_4'),
                buyLink: 'https://za.ecoflow.com/products/delta-pro-portable-power-station',
            },
        ],
        au: [
            {
                id: 'River2ProKit',
                img: 'product/R2+TS',
                name: t('secE_item1_title_1'),
                device: t('secE_item1_title_2'),
                power: t('secE_item1_title_3'),
                desc: t('secE_item1_title_4'),
                buyLink: 'https://au.ecoflow.com/collections/ecoflow-river-series/products/river-2-pro-portable-power-station',
            },
            {
                id: 'Delta2Kit',
                img: 'product/D2+D2EB+TS',
                name: t('secE_item2_title_1'),
                device: t('secE_item2_title_2'),
                power: t('secE_item2_title_3'),
                desc: t('secE_item2_title_4'),
                buyLink: 'https://au.ecoflow.com/products/delta-2-portable-power-station',
            },
            {
                id: 'DeltaProKit',
                img: 'product/DP+TS',
                name: t('secE_item3_title_1'),
                device: t('secE_item3_title_2'),
                power: t('secE_item3_title_3'),
                desc: t('secE_item3_title_4'),
                buyLink: 'https://au.ecoflow.com/products/delta-pro-portable-power-station',
            },
        ],
    };

    const solutionInfo = itemsMap[locale] || itemsMap.us;

    return (
        <div className={css.solutions}>
            <div className="content">
                <div className="title">{t('delta_pro_whole_home.solution_title')}</div>
                <div className="swiper">
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        className="solution-swiper"
                        pagination={{
                            clickable: true,
                        }}
                        navigation={false}
                        initialSlide={0}
                        autoplay={false}
                        speed={800}
                        lazy={true}
                        spaceBetween={10}
                        slidesPerView={'auto'}
                        centeredSlides={true}
                    >
                        {solutionInfo?.map((item: any, k: number) => (
                            <SwiperSlide key={k} className="solution-slide">
                                <SwiperCard item={item} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
